import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {ClanCandidate, ClanCandidateState} from "@/store/clan/types";
import {ListService} from "@/services/list-service";
import ClanUtils from "@/utils/clan-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ClanInvitePanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, c: ClanCandidate, profileCallback: () => unknown,
                inviteCallback: () => unknown, rejectCallback: () => unknown) {
        super(scene, canvas, c.name);
        this.setDepth(ListService.DEPTH + 1);

        let block1 = TextUtils.addTextAdvanced(scene, Tr('igrok') +  c.name, 0, -145,
            '#f3f3f3', 22, 'normal', 400, 'center', 2, Fonts.MYRIADPRO_REGULAR);

        let block2 = TextUtils.addTextAdvanced(scene, ClanUtils.getStatus(c.state), 0, block1.y / CU.S + 50,
            '#fff99a', 14, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        let block3 = TextUtils.addTextAdvanced(scene, Tr('ur.dot') + c.level + ', ' + Tr('best.v.lev') + ' ' + c.bestVictoryStair, 0, block2.y / CU.S + 40,
            '#e5e5e5', 12, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        let block4 = TextUtils.addTextAdvanced(scene, Tr('bil.v.igre') + c.lastActivityAt, 0, block3.y / CU.S + 40,
            '#afafaf', 12, 'normal', 400, 'center', 2, Fonts.ARIAL_MT);

        this.add([block1, block2, block3, block4]);

        switch (c.state) {
            case ClanCandidateState.WANTS_TO_ANY_CLAN:
                this.addCustomButton(-90, 130,Tr('v.profil'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL, profileCallback);
                this.addCustomButton(90, 130,Tr('priglasit'),
                    Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_MAIL, inviteCallback);
                break;
            case ClanCandidateState.WANTS_TO_THE_CLAN:
                SpriteUtils.scale(this.addCustomButton(-130, 150, Tr('v.profil'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_PROFILE_SOCIAL, profileCallback), 0.9);
                SpriteUtils.scale(this.addCustomButton(0, 150, Tr('rej'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_DECLINE_CROSS, rejectCallback), 0.9);
                SpriteUtils.scale(this.addCustomButton(130, 150, Tr('prinjat'), Keys.UI_ART_GREEN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, inviteCallback), 0.9);
                break;
            case ClanCandidateState.INVITED:
            case ClanCandidateState.REJECTED:
                this.addCustomButton(0, 130,Tr('horosho'), Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, () => {});
        }
    }

}
